import { Button, H3, P } from '../../typography';
import { ModalButtonGroup, StyledModal } from '../Modal.styled';

/* ---------------------------------- Types --------------------------------- */

interface DumbSignOutModalI {
    /** Callback to cancel log out */
    cancel: () => void;

    /** Dictionary string labels for the modal */
    labels: Record<string, string>;

    /** Callback to confirm log out */
    logout: () => void;
}

/* -------------------------------- Component ------------------------------- */

const DumbSignOutModal = ({ labels, cancel, logout }: DumbSignOutModalI) => (
    <StyledModal>
        <H3>{labels.title}</H3>
        <P>{labels.confirmation}</P>
        <ModalButtonGroup>
            <Button onClick={cancel}>{labels.cancelButton}</Button>
            <Button onClick={logout}>{labels.confirmButton}</Button>
        </ModalButtonGroup>
    </StyledModal>
);

/* --------------------------------- Export --------------------------------- */

export default DumbSignOutModal;
